import type { Middleware } from '@dynamic-labs/sdk-api-core';
import { isDeviceNonceSignatureRequiredForUrl } from '@dynamic-labs/sdk-api-core';

import type { DynamicClient } from '../../../../client/types';
import { getHeadersForNonceSignedByDeviceSigners } from '../../../deviceRegistration/getHeadersForNonceSignedByDeviceSigners';
import { isCookieEnabled } from '../../../projectSettings/isCookieEnabled';

export const createDeviceSignatureHeadersMiddleware = (
  client: DynamicClient
): Middleware => {
  return {
    pre: async (context) => {
      /**
       * The signed nonce is not required for cookie based environments.
       */
      if (
        isDeviceNonceSignatureRequiredForUrl(context.url) &&
        !isCookieEnabled(client)
      ) {
        const deviceSignerHeaders = await getHeadersForNonceSignedByDeviceSigners(
          client
        );

        return {
          init: {
            ...context.init,
            headers: {
              ...context.init.headers,
              ...deviceSignerHeaders,
            },
          },
          url: context.url,
        };
      }

      return;
    },
  };
};
